module.exports = __webpack_public_path__ + "media/promo/promo/images/mob-3-e1e455144f703c900da383d8b1f184ed.png";